// Cart-drawer cross-sell: theme port of the checkout extension's curated
// Rebuy-replacement (ESS360-checkout repo, extensions/ess360-checkout/src/
// crossSell.ts — keep the two in sync when the mapping changes). Offers add
// the ONE-TIME variant; the drawer's existing "Switch to Subscription" flow
// is the subscription on-ramp after the add. Adds are stamped with the same
// _ess360_cross_sell* line properties as checkout, with source 'cart' so
// attribution can split take-rate by surface.
$(document).ready(function () {
    var SUBSCRIPTION_RE = /subscription/i;
    var ONE_TIME_RE = /one[\s-]*time/i;

    var eliteFitSizes = {
        s: 'Small/Medium', m: 'Small/Medium', l: 'Large',
        xl: 'Extra Large', xxl: 'Extra Large', xxxl: 'Extra Large'
    };

    // key -> offer product. choiceOption: the option the customer picks in
    // step 2 (absent = one-tap direct add). pinned: options locked to one
    // value (Elite Fit color duo). sizeAlias: cart size -> this product's
    // option-value prefix. defaultChoice: preselect when no size match.
    var TARGETS = {
        'freedom-plus': {productId: 7046817480865, handle: 'freedom-plus-anytime-underwear', title: 'Freedom Plus Anytime Underwear', choiceOption: 'Size'},
        'security-plus': {productId: 7063157506209, handle: 'security-plus-overnight-underwear', title: 'Security Plus Overnight Underwear', choiceOption: 'Size'},
        'escape-plus': {productId: 7670998401185, handle: 'escape-plus-ultimate-protective-pads', title: 'Escape Plus Protective Pads', choiceOption: 'Size', defaultChoice: 'Ultimate'},
        'elite-fit': {productId: 7903411994785, handle: 'elite-fit-underwear', title: 'Elite Fit Underwear', choiceOption: 'Size', pinned: {Color: 'Beige'}, sizeAlias: eliteFitSizes},
        'elite-fit-gray': {productId: 7903411994785, handle: 'elite-fit-underwear', title: 'Elite Fit Underwear - Gray', choiceOption: 'Size', pinned: {Color: 'Gray'}, sizeAlias: eliteFitSizes},
        'booster-pads': {productId: 8180536017057, handle: 'booster-pads', title: 'Essentials 360 Booster Pads', choiceOption: 'Amount'},
        'maxcare-plus': {productId: 8181155233953, handle: 'maxcare-plus', title: 'MaxCare Plus Overnight Briefs', choiceOption: 'Size', sizeAlias: {s: 'Medium', m: 'Medium', l: 'Large', xl: 'XL/XXL', xxl: 'XL/XXL', xxxl: 'XL/XXL'}},
        'underpads': {productId: 8181312520353, handle: 'premium-disposable-underpads', title: 'Premium Disposable Underpads', choiceOption: 'Number Of Packs'},
        'wet-wipes': {productId: 8181305016481, handle: 'essentials-360-premium-wet-wipes', title: 'Essentials 360 Premium Wet Wipes', choiceOption: 'Number Of Packs'},
        'micro-towels': {productId: 7206084575393, handle: 'essentials-360-micro-towels', title: 'Essentials 360 Micro Towels'},
        // $3.95 sample packs for Freedom Plus trial carts (Shibani + Kyle,
        // 2026-10-27): one Sample Packs product, Product option pins the item.
        // sampleOf: the full-size core product (hides the offer when it's in
        // the cart; its image is shown instead of the generic sample shot).
        'security-plus-sample': {productId: 8525299876001, handle: 'freedom-plus-trial-kit-copy', title: 'Security Plus Overnight Underwear - Sample (2 Pack)', choiceOption: 'Size', pinned: {Product: 'Security Plus Overnight Underwear (Qty: 2)'}, sizeAlias: {s: 'Small', m: 'Medium', l: 'Large', xl: 'X-Large', xxl: '2X-Large', xxxl: '3X-Large'}, sampleOf: 7063157506209},
        // One physical pack: 2 boosters + 1 underpad (Kyle); the Underpads
        // variant is the same pack, so it isn't offered.
        'booster-pads-sample': {productId: 8525299876001, handle: 'freedom-plus-trial-kit-copy', title: 'Booster Pads (2) + Underpad (1) - Sample', pinned: {Product: 'Booster Pads (Qty: 2)'}, sampleOf: 8180536017057},
        'elite-fit-sample': {productId: 8525299876001, handle: 'freedom-plus-trial-kit-copy', title: 'Elite Fit Underwear - Sample (2 Pack)', choiceOption: 'Size', pinned: {Product: 'Elite Fit Discreet Underwear (Qty: 2)'}, sizeAlias: {s: 'Small/Medium', m: 'Small/Medium', l: 'Large', xl: 'X-Large', xxl: 'X-Large', xxxl: 'X-Large'}, sampleOf: 7903411994785}
    };

    // Freedom Plus $12.95 and $4.95 trial kits: carts with one get the
    // Freedom Plus row's trialOffers instead of its offers.
    var TRIAL_PRODUCTS = {8339688882337: true, 8271407284385: true, 8684346769569: true, 8807733067937: true};

    // Offer/variant products -> the core product whose row they anchor (and
    // whose family excludes them as an offer).
    var FAMILY_CORE = {};
    function family(core, members) {
        FAMILY_CORE[core] = core;
        for (var i = 0; i < members.length; i++) FAMILY_CORE[members[i]] = core;
    }
    family(7046817480865, [8370407080097, 8339688882337, 8271407284385, 8684346769569, 8486601523361, 8259118891169, 8130823389345, 8807733067937]);
    family(7063157506209, []);
    family(7670998401185, [8302210351265, 8486622101665, 8130828533921, 8236482887841, 8732913729697]);
    family(7903411994785, [8297388081313, 8494701510817, 8494700789921]);
    family(8180536017057, []);
    family(8231227523233, [8297391194273, 8486662930593, 8494700658849]);
    family(8181155233953, []);
    family(8181312520353, []);
    family(8181305016481, []);
    family(7206084575393, []);

    // Anchor value stamped on adds: the core product's handle (matches what
    // the checkout extension stamps, so anchors compare across surfaces).
    var ANCHOR_HANDLES = {
        7046817480865: 'freedom-plus-anytime-underwear',
        7063157506209: 'security-plus-overnight-underwear',
        7670998401185: 'escape-plus-ultimate-protective-pads',
        7903411994785: 'elite-fit-underwear',
        8180536017057: 'booster-pads',
        8231227523233: 'secure-shield-male-guards',
        8181155233953: 'maxcare-plus',
        8181312520353: 'premium-disposable-underpads',
        8181305016481: 'essentials-360-premium-wet-wipes',
        7206084575393: 'essentials-360-micro-towels'
    };

    // Anchor rows in priority order (row order = total sales, column order =
    // offer priority).
    var ROWS = [
        {core: 7046817480865, offers: ['security-plus', 'booster-pads', 'escape-plus'],
            trialOffers: ['security-plus-sample', 'booster-pads-sample', 'elite-fit-sample']},
        {core: 7063157506209, offers: ['underpads', 'maxcare-plus', 'booster-pads']},
        {core: 7670998401185, offers: ['elite-fit', 'freedom-plus', 'wet-wipes']},
        {core: 7903411994785, offers: ['escape-plus', 'freedom-plus', 'wet-wipes']},
        {core: 8180536017057, offers: ['underpads', 'security-plus', 'wet-wipes']},
        {core: 8231227523233, offers: ['elite-fit-gray', 'wet-wipes', 'micro-towels']},
        {core: 8181155233953, offers: ['booster-pads', 'underpads', 'wet-wipes']},
        {core: 8181312520353, offers: ['booster-pads', 'maxcare-plus', 'wet-wipes']},
        {core: 8181305016481, offers: ['security-plus', 'underpads', 'freedom-plus']},
        {core: 7206084575393, offers: ['freedom-plus', 'wet-wipes', 'security-plus']}
    ];

    // Size-label prefixes -> canonical token, most specific first. Prefix-
    // anchored so Escape Plus pad styles ("Maximum - Medium Length") never
    // match.
    var SIZE_PATTERNS = [
        [/^XXXL\b/i, 'XXXL'], [/^XXL\b/i, 'XXL'], [/^XL\b/i, 'XL'],
        [/^Extra Large\b/i, 'XL'], [/^Small\/Medium\b/i, 'M'], [/^Large\b/i, 'L'],
        [/^Medium\b/i, 'M'], [/^Small\b/i, 'S'],
        [/^L\b/i, 'L'], [/^M\b/i, 'M'], [/^S\b/i, 'S']
    ];

    function isSubscriptionVariant(variant) {
        var texts = [variant.title || ''].concat(variant.options || []);
        for (var i = 0; i < texts.length; i++) if (ONE_TIME_RE.test(texts[i])) return false;
        for (var j = 0; j < texts.length; j++) if (SUBSCRIPTION_RE.test(texts[j])) return true;
        return !!variant.sku && /-AS$/i.test(variant.sku);
    }

    function optionValue(product, variant, name) {
        for (var i = 0; i < product.options.length; i++) {
            var optName = typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name;
            if (optName === name) return variant.options[i] || null;
        }
        return null;
    }

    // Cross-sell products for this cart: walk anchor rows in priority order,
    // drop offers whose family is already in the cart, dedupe, cap at 3.
    function selectTargets(cartItems) {
        var inCart = {};
        var trial = false;
        for (var i = 0; i < cartItems.length; i++) {
            var core = FAMILY_CORE[cartItems[i].product_id];
            if (core) inCart[core] = true;
            if (TRIAL_PRODUCTS[cartItems[i].product_id]) trial = true;
        }
        // A sample already in the cart: same product with its pinned options.
        function sampleInCart(target) {
            for (var c = 0; c < cartItems.length; c++) {
                if (cartItems[c].product_id !== target.productId) continue;
                var opts = cartItems[c].options_with_values || [];
                var match = true;
                for (var name in target.pinned) {
                    var found = false;
                    for (var p = 0; p < opts.length; p++) {
                        if (opts[p].name === name && opts[p].value === target.pinned[name]) found = true;
                    }
                    if (!found) match = false;
                }
                if (match) return true;
            }
            return false;
        }
        var picked = [];
        var pickedProducts = {};
        for (var r = 0; r < ROWS.length; r++) {
            var row = ROWS[r];
            if (!inCart[row.core]) continue;
            var offers = trial && row.trialOffers ? row.trialOffers : row.offers;
            for (var o = 0; o < offers.length; o++) {
                var target = TARGETS[offers[o]];
                if (target.sampleOf) {
                    if (inCart[target.sampleOf] || sampleInCart(target)) continue;
                } else if (inCart[FAMILY_CORE[target.productId]]) continue;
                // Samples share one product, so they dedupe by key.
                var dedupe = target.sampleOf ? offers[o] : target.productId;
                if (pickedProducts[dedupe]) continue;
                picked.push({key: offers[o], target: target, anchor: ANCHOR_HANDLES[row.core]});
                pickedProducts[dedupe] = true;
                if (picked.length === 3) return picked;
            }
        }
        return picked;
    }

    // Normalized size (S/M/L/...) of the first cart line whose Size option
    // carries a recognizable label — preselects the size on sized offers.
    function cartSize(cartItems) {
        for (var i = 0; i < cartItems.length; i++) {
            var opts = cartItems[i].options_with_values || [];
            for (var o = 0; o < opts.length; o++) {
                if (!opts[o].name || !/^size$/i.test(opts[o].name) || !opts[o].value) continue;
                var value = String(opts[o].value).trim();
                for (var p = 0; p < SIZE_PATTERNS.length; p++) {
                    if (SIZE_PATTERNS[p][0].test(value)) return SIZE_PATTERNS[p][1];
                }
            }
        }
        return null;
    }

    function escapeRe(s) {
        return s.replace(/[.*+?^${}()|[\]\\/-]/g, '\\$&');
    }

    // One offer from the product's live variants: one-time only, pinned
    // options enforced, one choice per choiceOption value, cart size
    // preselected where the product has an equivalent. Null when no
    // one-time variant exists.
    function buildOffer(target, product, size) {
        var seen = {};
        var choices = [];
        for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            if (v.available === false) continue;
            if (isSubscriptionVariant(v)) continue;
            var pinnedOk = true;
            if (target.pinned) {
                for (var name in target.pinned) {
                    if (optionValue(product, v, name) !== target.pinned[name]) pinnedOk = false;
                }
            }
            if (!pinnedOk) continue;
            var label = target.choiceOption ? (optionValue(product, v, target.choiceOption) || '') : '';
            if (seen[label]) continue;
            seen[label] = true;
            choices.push({label: label, variantId: v.id, price: v.price});
        }
        if (choices.length === 0) return null;

        function findByPrefix(prefix) {
            if (!prefix) return -1;
            var re = new RegExp('^' + escapeRe(prefix) + '\\b', 'i');
            for (var c = 0; c < choices.length; c++) if (re.test(choices[c].label)) return c;
            return -1;
        }
        var sizePrefix = size ? (target.sizeAlias ? target.sizeAlias[size.toLowerCase()] : size) : null;
        var defaultIndex = findByPrefix(sizePrefix);
        if (defaultIndex < 0) defaultIndex = findByPrefix(target.defaultChoice);
        if (defaultIndex < 0) defaultIndex = 0;
        return {choices: choices, defaultIndex: defaultIndex, directAdd: choices.length === 1};
    }

    // One product-JSON fetch per handle for the page; failures aren't cached
    // so a later render retries. Resolved through our own single-value
    // Deferred: $.when hands multi-value ajax resolutions to the join
    // callback as [data, status, xhr] arrays, single-value ones as the value.
    var productCache = {};
    function fetchProduct(handle) {
        if (!productCache[handle]) {
            var resolved = $.Deferred();
            $.getJSON('/products/' + handle + '.js')
                .done(function (data) { resolved.resolve(data); })
                .fail(function () {
                    delete productCache[handle];
                    resolved.resolve(null);
                });
            productCache[handle] = resolved.promise();
        }
        return productCache[handle];
    }

    // Matches the drawer's Liquid money format ("$90.00").
    function money(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    function escapeHtml(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function productImage(product) {
        var src = (product.featured_image || (product.images && product.images[0]) || '');
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=180';
    }

    // Offers rendered this pass, indexed by slot, for the click handlers.
    var currentOffers = [];

    function cardHtml(offer, slot) {
        var choice = offer.offer.choices[offer.offer.defaultIndex];
        var img = productImage(offer.imageProduct || offer.product);
        var sub = choice.label ? escapeHtml(choice.label) + ' / One-Time Purchase' : 'One-Time Purchase';
        return '<div class="block__cart-drawer-cross-sell-card" data-cross-sell-slot="' + slot + '">' +
            (img ? '<img class="block__cart-drawer-cross-sell-img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(offer.target.title) + '" loading="lazy">' : '') +
            '<div class="block__cart-drawer-cross-sell-info">' +
                '<div class="block__cart-drawer-cross-sell-title">' + escapeHtml(offer.target.title) + '</div>' +
                '<div class="block__cart-drawer-cross-sell-sub js-cross-sell-sub">' + sub + '</div>' +
                '<div class="block__cart-drawer-cross-sell-price js-cross-sell-price">' + money(choice.price) + '</div>' +
                '<div class="block__cart-drawer-cross-sell-picker js-cross-sell-picker" hidden>' +
                    '<select class="block__cart-drawer-cross-sell-select js-cross-sell-select" aria-label="' + escapeHtml(offer.target.choiceOption || 'Option') + '">' +
                        $.map(offer.offer.choices, function (c, i) {
                            return '<option value="' + i + '"' + (i === offer.offer.defaultIndex ? ' selected' : '') + '>' + escapeHtml(c.label) + '</option>';
                        }).join('') +
                    '</select>' +
                '</div>' +
            '</div>' +
            '<button type="button" class="block__cart-drawer-cross-sell-btn js-cross-sell-btn">' + (offer.offer.directAdd ? 'Add' : 'Select') + '</button>' +
        '</div>';
    }

    function render() {
        var $box = $('.js-cart-cross-sell');
        if ($box.length === 0) return;
        var renderPass = ($box.data('cross-sell-pass') || 0) + 1;
        $box.data('cross-sell-pass', renderPass);

        $.getJSON('/cart.js', function (cart) {
            if ($box.data('cross-sell-pass') !== renderPass) return;
            var targets = selectTargets(cart.items);
            if (targets.length === 0) {
                $box.empty();
                return;
            }
            var size = cartSize(cart.items);
            // Samples share one generic image; fetch the full-size product's too.
            var fetches = $.map(targets, function (t) { return fetchProduct(t.target.handle); })
                .concat($.map(targets, function (t) {
                    return fetchProduct(t.target.sampleOf ? ANCHOR_HANDLES[t.target.sampleOf] : t.target.handle);
                }));
            $.when.apply($, fetches)
                .then(function () {
                    if ($box.data('cross-sell-pass') !== renderPass) return;
                    var products = arguments;
                    var offers = [];
                    for (var i = 0; i < targets.length; i++) {
                        var product = products[i];
                        if (!product) continue;
                        var offer = buildOffer(targets[i].target, product, size);
                        if (offer) offers.push({target: targets[i].target, anchor: targets[i].anchor, product: product, imageProduct: products[i + targets.length], offer: offer});
                    }
                    currentOffers = offers;
                    if (offers.length === 0) {
                        $box.empty();
                        return;
                    }
                    var html = '<div class="block__cart-drawer-cross-sell-heading">You may also like</div>';
                    for (var o = 0; o < offers.length; o++) html += cardHtml(offers[o], o);
                    $box.html(html);
                });
        });
    }

    $(document).on('click', '.js-cross-sell-btn', function () {
        var $btn = $(this);
        var $card = $btn.closest('.block__cart-drawer-cross-sell-card');
        var offer = currentOffers[$card.data('cross-sell-slot')];
        if (!offer) return;

        if (!offer.offer.directAdd && !$card.hasClass('is-expanded')) {
            $card.addClass('is-expanded');
            $card.find('.js-cross-sell-picker').prop('hidden', false);
            $btn.text('Add');
            return;
        }

        var index = offer.offer.directAdd ? 0 : parseInt($card.find('.js-cross-sell-select').val(), 10) || 0;
        var choice = offer.offer.choices[index];
        var sizeBehavior = offer.offer.directAdd ? 'direct'
            : (index === offer.offer.defaultIndex ? 'preselected' : 'changed');
        var slot = $card.data('cross-sell-slot') + 1;

        $btn.prop('disabled', true).addClass('loading');
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                id: choice.variantId,
                quantity: 1,
                properties: {
                    _ess360_cross_sell: 'cart',
                    _ess360_cross_sell_anchor: offer.anchor,
                    _ess360_cross_sell_slot: String(slot),
                    _ess360_cross_sell_size: sizeBehavior
                }
            }),
            success: function () {
                // Refresh the drawer ourselves with native APIs: the page
                // loads several jQuery copies at unpredictable times (GTM/app
                // embeds), so cart-drawer.js's jQuery-global interceptors may
                // be bound to a different instance than ours and never see
                // this add. The section replacement below trips the
                // MutationObserver at the bottom, which re-renders the offers.
                refreshDrawerSection();
                $(document).trigger('cart:change');
            },
            error: function () {
                $btn.prop('disabled', false).removeClass('loading');
            }
        });
    });

    // Native-fetch equivalent of cart-drawer.js's CartDrawerRefresh.
    function refreshDrawerSection() {
        fetch('/?section_id=new-cart-drawer')
            .then(function (r) { return r.text(); })
            .then(function (html) {
                var section = document.querySelector('.js-cart-drawer-section');
                var fresh = new DOMParser().parseFromString(html, 'text/html')
                    .querySelector('.js-cart-drawer-section');
                if (section && fresh) section.innerHTML = fresh.innerHTML;
                return fetch('/cart.js').then(function (r) { return r.json(); });
            })
            .then(function (cart) {
                var counts = document.querySelectorAll('.js-cart-item-count');
                for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
            })
            .catch(function () {});
    }

    // Keep the price + sub-line in step with the picker.
    $(document).on('change', '.js-cross-sell-select', function () {
        var $card = $(this).closest('.block__cart-drawer-cross-sell-card');
        var offer = currentOffers[$card.data('cross-sell-slot')];
        if (!offer) return;
        var choice = offer.offer.choices[parseInt($(this).val(), 10) || 0];
        if (!choice) return;
        $card.find('.js-cross-sell-price').text(money(choice.price));
        $card.find('.js-cross-sell-sub').text(choice.label ? choice.label + ' / One-Time Purchase' : 'One-Time Purchase');
    });

    // Re-render whenever the drawer section HTML is refreshed (cart-drawer.js
    // replaces the section's children on every cart change / drawer open),
    // and once on load. A native MutationObserver — NOT jQuery's global ajax
    // events — because the page loads several jQuery copies at unpredictable
    // times and a late copy replaces window.$ after our handlers bind; the
    // drawer's refresh then runs on an instance that never calls handlers
    // registered on ours. DOM mutations are visible no matter which jQuery
    // (or fetch) performed the replacement. subtree:false means our own
    // painting into the (deeper) container can't re-trigger the observer.
    var sectionEl = document.querySelector('.js-cart-drawer-section');
    if (sectionEl) {
        new MutationObserver(function () { render(); })
            .observe(sectionEl, {childList: true});
    }
    render();
});
